import MoreVertIcon from "@mui/icons-material/MoreVert";
import React from "react";
import AcxButton from "../AcxButton";

interface IFilterIcon {
    onClick: (event: React.MouseEvent<HTMLElement>) => void;
    isDisabled?: boolean;
}

const VertIcon = (props: IFilterIcon) => {
    return (
        <AcxButton
            disabled={props.isDisabled ?? false}
            onClick={props.onClick as any}
            color="white"
            containerStyle={{ width: "30px", height: "30px" }}
            sx={(theme) => ({
                width: "30px",
                height: "30px",
                minWidth: "0px",
                fontSize: "16px",
                padding: theme.spacing(1),
            })}
        >
            <MoreVertIcon />
        </AcxButton>
    );
};

export default VertIcon;
